import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Modal from "react-bootstrap/Modal";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { createNotification } from '../../../shared/components/Popup';
import { getLoginInfo } from '../../../shared/utils/storage';

import FormLabel from "@mui/material/FormLabel";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import { event } from "jquery";
import { protectedApi } from '../../../shared/services/apiService';
import { addUserFormValidator } from '../../../shared/validators/FormValidator';

const AddUser = ({ isOpen, UserID, clearModalState }) => {
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [userName, setUserName] = useState();
  const [isUpdate, setIsUpdate] = useState(true);
  const [PFNo, setPFNo] = useState();
  const [MobileNo, setMobileNo] = useState();
  const [groupID, setGroupID] = useState();
  const [ETDAssessment, setETDAssessment] = useState();
  const [ETDApproval, setETDApproval] = useState();
  const [report, setReport] = useState();
  const [ETDManager, setETDManager] = useState();
  const [stationData, setSationData] = useState([]);
  const [StationID, setStationID] = useState("");
  const [showFirstModal, setShowFirstModal] = useState(false);
  const [showSecondModal, setShowSecondModal] = useState(false);
  const [regionData, setRegionData] = useState([]);
  const [regionID, setRegionID] = useState("");
  const [userData, setUserData] = useState({
    FullName: "",
    UserName: "",
    Station: "",
    StationID: "",
    UserStation: "",
    PFNo: "",
    phoneNumber: "",
    Position: "",
    TerritoryID: "",
    GroupID: "", // Keep consistent casing
    UserID: "",
    Email: "",
    MobileNo: "",
    ETDAssessment: 0,
    ETDApproval: 0,
    report: 0,
    ETDManager: 0,
  });

  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleShowFirstModal = () => {
    setIsUpdate(false);
    setShowFirstModal(true);
    getStations();
  };
  const handleCloseFirstModal = () => {
    setShowFirstModal(false);
    setUserName(null);
  };
  const handleCloseSecondModal = () => {
    setShowSecondModal(false);
    clearModalState(false);
    setUserData((prevState) => ({ ...prevState, ...[null] }));
    //  setPFNo(null);
    //setEmail(null);

    setMobileNo(null);
    setETDAssessment(null);
    setETDApproval(null);
    setReport(null);
    setETDManager(null);
    setUserData({
      FullName: "",
      UserName: "",
      Station: "",
      PFNo: "",
      phoneNumber: "",
      Position: "",
      TerritoryID: "",
      GroupID: "",
      UserID: "",
      Email: "",
      MobileNo: "",
      ETDAssessment: 0,
      ETDApproval: 0,
      report: 0,
      ETDManager: 0,
    });
  };

  const searchUserSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const PullData = {
      OperationType: "USER",
      UserName: getLoginInfo().Username,
      Station: getLoginInfo().Station,
      UserID: userName,
    };
    const result = await handleApplicationManagement(
      PullData,
      "user_management",
    );
    setLoading(false);
    if (result?.code == 1) {
      setUserData((prevState) => ({ ...prevState, ...result?.data[0] }));
      setIsUpdate(false);
      setShowSecondModal(true);
      handleCloseFirstModal();
    } else {
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };

  const addUser = async (e) => {
    e.preventDefault();
    const validationErrors = addUserFormValidator(userData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setErrors({});
    setLoading(true);
    const PullData = {
      OperationType: isUpdate ? "UPDATE" : "ADDUSER",
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
      UserStation: userData?.Station,
      RequiredUserID: userData?.UserID,
      RequiredUserName: userData?.Username,
      ETDAproval: userData?.ETDApproval,
      ETDAccoutant: userData?.ETDAccoutant,
      ETDAssessment: userData?.ETDAssessment,
      ETDManager: userData?.ETDManager,
      Email: userData?.Email,
      FullName: userData?.FullName,
      GroupID: userData?.GroupID,
      MobileNo: userData?.MobileNo,
      // phoneNumber: userData?.MobileNo,
      PFNo: userData?.PFNo,
      StationID: userData?.StationID,
      Position: userData?.Position,
      TerritoryID: userData?.TerritoryID,
    };

    const result = await handleApplicationManagement(
      PullData,
      "user_management",
    );
    setLoading(false);
    if (result?.code == 1) {
      const info = { type: "success", message: result?.message };
      handleCloseSecondModal();
      createNotification(info)();
    } else {
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };

  const staffInformation = {
    OperationType: "USER",
    UserName: getLoginInfo().Username,
    Station: getLoginInfo().Station,
    UserID: UserID,
  };

  useEffect(() => {
    setPermission();
    if (UserID) {
      fetchData();
    }
  }, [UserID]);
  const fetchData = async () => {
    try {
      const result = await handleApplicationManagement(
        staffInformation,
        "user_management",
      );
      if (result.code == 1) {
        setUserData((prevState) => ({ ...prevState, ...result?.data[0] }));
        getStations();
        setShowSecondModal(isOpen);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  //----------------------------------------Station
  const getStations = async () => {
    const payload = {
      ApplicationId: null,
      UserName: getLoginInfo()?.user?.Username,
      Station: getLoginInfo()?.user?.StationID,
      ResourceParam: "",
      ResourceParam2: "null",
      ResourceType: "Station",
    };

    const result = await protectedApi(payload, "lookup");
    if (result?.code == 1) {
      setSationData(result.data);
    } else {
      const info = { type: "error", message: result?.message };
      createNotification(info)();
    }
  };

  const setPermission = () => {
    let groupId = getLoginInfo()?.user?.GroupID;
    setGroupID(groupId);
  };

  return (
    <>
      <button className="btn-warning" onClick={handleShowFirstModal}>
        User Registration <i className="fa fa-user-plus"></i>
      </button>

      {/* First Modal */}
      <Modal show={showFirstModal} onHide={handleCloseFirstModal} centered>
        <form onSubmit={searchUserSubmit}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "black" }}>Search User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Box
              display="flex"
              justifyContent="center"
              sx={{ "& > :not(style)": { m: 1 } }}
            >
              <div></div>
              <div className="col-md-6">
                <TextField
                  id="PFNumber"
                  label="Username"
                  name="PFNumber"
                  onChange={(e) => setUserName(e.target.value)}
                  value={userName}
                  fullWidth
                  required
                />
              </div>
              <div></div>
            </Box>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCloseFirstModal}
            >
              Clear / Close
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
            >
              {loading ? (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                >
                  Loading..
                </span>
              ) : (
                "Add User"
              )}
            </button>
          </Modal.Footer>
        </form>
      </Modal>

      {/* Second Modal */}
      <Modal show={showSecondModal} onHide={handleCloseSecondModal} centered>
        <form onSubmit={addUser}>
          <Modal.Header closeButton>
            <Modal.Title style={{ color: "black" }}>
              User Registration
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="col-md-12">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  "& > :not(style)": {
                    m: 1,
                    width: "30ch",
                  },
                }}
              >
                <TextField
                  id="FullName"
                  label="Full Name"
                  name="FullName"
                  onChange={handleInputChange}
                  value={userData?.FullName}
                  required
                  disabled
                />
                <TextField
                  id="UserName"
                  label="Username"
                  name="UserName"
                  onChange={handleInputChange}
                  value={userData?.Username}
                  required
                  disabled
                />
                {/* <TextField
                  id="Station"
                  label="Station"
                  name="Station"
                  onChange={handleInputChange}
                  value={userData?.Station}
                  required

                /> */}
              </Box>

              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  "& > :not(style)": {
                    m: 1,
                    width: "30ch",
                  },
                }}
              >
                <TextField
                  id="PFNo"
                  label="PF Number"
                  name="PFNo"
                  onChange={handleInputChange}
                  value={userData?.PFNo}
                  required
                  error={!!errors.PFNo}
                  helperText={errors.PFNo}
                />

                <TextField
                  id="Email"
                  label="Email Address"
                  name="Email"
                  onChange={handleInputChange}
                  value={userData?.Email}
                  required
                  error={!!errors.Email}
                  helperText={errors.Email}
                />
                <TextField
                  id="MobileNo"
                  label="Mobile Number"
                  name="MobileNo"
                  onChange={handleInputChange}
                  value={userData?.MobileNo}
                  required
                  error={!!errors.MobileNo}
                  helperText={errors.MobileNo}
                />
              </Box>

              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  "& > :not(style)": {
                    m: 1,
                    width: "30ch",
                  },
                }}
              >
                <FormControl>
                  <InputLabel id="TerritoryID">Territory</InputLabel>
                  <Select
                    id="TerritoryID"
                    label="Territory"
                    name="TerritoryID" // Matches the key in the state
                    value={userData.TerritoryID || ""} // Provide a default empty value to prevent uncontrolled component issues
                    onChange={(e) => handleInputChange(e)}
                  >
                    <MenuItem value="">Chagua Eneo</MenuItem>
                    <MenuItem value="1">Tanzania Mainland</MenuItem>
                    <MenuItem value="2">Zanzibar</MenuItem>
                    <MenuItem value="3">Ubalozi</MenuItem>
                  </Select>
                </FormControl>
                {/* <FormControl focused required>
                  <InputLabel id="Region">Region/State</InputLabel>
                  <Select
                    id="Region"
                    label="Region/State"
                    onChange={regionInputChange}
                    value={regionID}
                  >
                    {regionData?.map((obj) => {
                      return (
                        <MenuItem key={obj.Region} value={obj.Region}>
                          {obj.Region}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl> */}

                <FormControl focused required>
                  <InputLabel id="StationID">Station</InputLabel>
                  <Select
                    label="Station"
                    id="StationID"
                    name="StationID"
                    value={userData?.StationID}
                    onChange={handleInputChange}
                  >
                    {stationData?.map((obj) => {
                      return (
                        <MenuItem key={obj?.ResourceID} value={obj?.ResourceID}>
                          {obj.ResourceName}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>

                <FormControl>
                  <InputLabel id="GroupID">Group</InputLabel>
                  <Select
                    id="GroupID"
                    label="Group"
                    name="GroupID" // Matches the key in the state
                    value={userData.GroupID || ""} // Provide a default empty value to prevent uncontrolled component issues
                    onChange={(e) => handleInputChange(e)}
                  >
                    <MenuItem value="">Chagua group</MenuItem>
                    {groupID == 1 && <MenuItem value="1">Super User</MenuItem>}
                    {groupID == 1 && <MenuItem value="2">RIO Admin</MenuItem>}
                    <MenuItem value="3">User</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {/* privalege */}
              {userData?.GroupID == "3" ? (
                <div className="col-md-12">
                  <Box
                    display="flex"
                    alignItems="top"
                    justifyContent="center"
                    sx={{
                      "& > :not(style)": {
                        m: 1,
                        width: "30ch",
                      },
                    }}
                  >
                    <card>
                      <FormControl
                        sx={{ m: 3 }}
                        component="fieldset"
                        variant="standard"
                      >
                        <FormLabel component="legend">
                          <b>Assessment</b>
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            label="ETD"
                            control={
                              <Checkbox
                                id="ETDAssessment"
                                name="ETDAssessment"
                                checked={userData?.ETDAssessment || 0} // Bind checked prop to state
                                onChange={(e) =>
                                  handleInputChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked,
                                    }, // Map checked value to state
                                  })
                                }
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    </card>

                    <card>
                      <FormControl
                        sx={{ m: 3 }}
                        component="fieldset"
                        variant="standard"
                      >
                        <FormLabel component="legend">
                          <b>Approval</b>
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            label="ETD"
                            control={
                              <Checkbox
                                id="ETDApproval"
                                name="ETDApproval"
                                checked={userData?.ETDApproval || 0} // Bind checked prop to state
                                onChange={(e) =>
                                  handleInputChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked,
                                    }, // Map checked value to state
                                  })
                                }
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    </card>

                    <card>
                      <FormControl
                        sx={{ m: 3 }}
                        component="fieldset"
                        variant="standard"
                      >
                        <FormLabel component="legend">
                          <b>PO1</b>
                        </FormLabel>
                        <FormGroup>
                          <FormControlLabel
                            label="ETD"
                            control={
                              <Checkbox
                                id="ETDManager"
                                name="ETDManager"
                                checked={userData?.ETDManager || 0} // Bind checked prop to state
                                onChange={(e) =>
                                  handleInputChange({
                                    target: {
                                      name: e.target.name,
                                      value: e.target.checked,
                                    }, // Map checked value to state
                                  })
                                }
                              />
                            }
                          />
                        </FormGroup>
                      </FormControl>
                    </card>
                  </Box>
                </div>
              ) : (
                ""
              )}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn btn-secondary"
              type="button"
              onClick={handleCloseSecondModal}
            >
              Close
            </button>
            <button
              className="btn btn-primary"
              type="submit"
              disabled={loading}
            >
              {isUpdate ? "Update" : "Add User"}
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AddUser;
